import { FormattedNumber } from 'react-intl';
import React, { Component } from 'react';

import './styles/Stat.css';
import { color, math } from '../utilities';
import EXPERIENCE_TABLE from '../constants/experienceTable';
import SkillIcon from './SkillIcon';

class OverallStat extends Component {
  getExperience = (level = 1) => EXPERIENCE_TABLE.find(EXP => EXP.level === level) || {};

  getMaxProgress = (exp = 0) => {
    const expMax = this.getExperience(127);
    return math.fixed((exp / expMax) * 100);
  };

  getLevelProgress = (level = 1, exp = 0) => {
    const currentLevel = this.getExperience(level) || 0;
    const nextLevel = this.getExperience(level+1) || 0;

    return {
      needed: nextLevel.exp - exp,
      progress: (exp - currentLevel.exp) / (nextLevel.exp - currentLevel.exp) * 100
    };
  };

  getAverageLevel = (stats = []) => {
    let average = 0;
    let count = 0;
    // let isMember = !isProbablyNotMember(stats);

    stats.forEach((stat) => {
      // if (isMember || !isMemberSkill(stat.statKey)) {
        average += stat.details.level;
        count++;
      // }
    });

    return math.fixed(average / count);
  }

  getDeviation = (stats = []) => {
    const averageLevel = this.getAverageLevel(stats);
    const diffs = stats.map((stat) => {
      const diff = stat.details.level - averageLevel;
      return Math.pow(diff, 2);
    });
    const averageDiffs = math.average(diffs);
    const stdDev = Math.sqrt(averageDiffs);

    return math.fixed(stdDev);
  }

  render() {
    const { formatting, stat, stats } = this.props;

    const getFormatting = formatting => {
      if (formatting === 'tiny') {
        return 'tiny';
      } else if (formatting === 'compact') {
        return 'compact';
      }

      return '';
    }

    const getStatValue = (stat, key) => {
      return stat && stat.details ? stat.details[key] : 1;
    };

    return (
      <div className={`stat-group stat-group-overall group-tight ${getFormatting(formatting)}`} style={{ 'backgroundColor': color.getOverallColor(getStatValue(stat, 'level')) }}>
        <div className="stat-content">
          <h5 className="stat-name narrow">
            <SkillIcon icon={'rparty'} name={'Overall'} />
            Overall (<FormattedNumber value={getStatValue(stat, 'level')} />)
          </h5>
          <div className="row">
            <div className="stat-detail columns collapse shrink">
              <p><strong>EXP:</strong> <FormattedNumber value={getStatValue(stat, 'exp')} /></p>
            </div>
            <div className="stat-detail columns collapse shrink">
              <p><strong>AVG:</strong> <FormattedNumber value={this.getAverageLevel(stats)} /></p>
            </div>
            <div className="stat-detail columns collapse shrink">
              <p><strong>DEVIATION:</strong> <FormattedNumber value={this.getDeviation(stats)} /></p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OverallStat;



// WEBPACK FOOTER //
// ./src/components/OverallStat.js